/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output } from '@angular/core';

import { AppUtilityService } from '../../core/services/app-utility.service';

/**
 * @export
 * @class LmsViewportPagingDirective
 * @implements {AfterViewInit}
 */
@Directive({
  selector: '[lmsViewportPaging]',
  exportAs: 'viewPortpaging'
})
export class LmsViewportPagingDirective implements AfterViewInit, OnChanges {
  @Input() child: String;
  @Output() getPagingData = new EventEmitter();
  private heightArray: Array<number>;
  private totalheight: number;
  private directiveElement;

  constructor(private eRef: ElementRef, private appUtilityService: AppUtilityService) {
    this.directiveElement = this.eRef.nativeElement;
    this.heightArray = [];
  }

  /**
   * This methods finds the container height and its child height to set paging.
   * @memberOf LmsViewportPagingDirective
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.updateScreenSizeSetting();
    }, 200);
  }

  ngOnChanges() {
    this.updateScreenSizeSetting();
  }

  /**
   * This add scroll Event
   * @param {any} e
   * @memberOf LmsViewportPagingDirective
   */
  @HostListener('scroll', ['$event'])
  onScroll(e) {
    this.setChildsHeight();
    this.setPaging();
  }

  /**
   * This adds resize event
   * @param {any} e
   * @memberOf LmsViewportPagingDirective
   */
  @HostListener('window:resize', ['$event'])
  onResize(e) {
    setTimeout(() => {
      this.updateScreenSizeSetting();
    }, 200);
  }

  updateScreenSizeSetting() {
    this.findContainerTotalHeight();
    this.setChildsHeight();
    this.setPaging();
  }
  /**
   * by this we got total height of container
   * @memberOf ViewportPagingDirective
   */
  private findContainerTotalHeight() {
    this.totalheight = this.directiveElement.offsetHeight;
  }

  /**
   * this method set paging start and end
   * parameter so we can use at the time of scroll
   * @private
   * @memberOf ViewportPagingDirective
   */
  private setPaging() {
    const heightArrayLength = this.heightArray.length;
    if (this.directiveElement.scrollHeight > this.directiveElement.clientHeight) {
      let currentScrollPosition = this.directiveElement.scrollTop;
      let currentBottomScroll = currentScrollPosition + this.directiveElement.clientHeight;
      let start = 0;
      let end = 0;
      for (let i = 0; i < heightArrayLength; i++) {
        let widthOfCurrentRow;
        if (i > 0) {
          widthOfCurrentRow = this.heightArray[i] - this.heightArray[i - 1];
        } else {
          widthOfCurrentRow = this.heightArray[i];
        }
        currentScrollPosition = currentScrollPosition - widthOfCurrentRow;
        if (start === 0 && currentScrollPosition < 0) {
          start = i + 1;
        }
        currentBottomScroll = currentBottomScroll - widthOfCurrentRow;
        if (end === 0 && currentBottomScroll <= 0) {
          end = i + 1;
        }
        if (start > 0 && end > 0) {
          this.getPagingData.emit({ paging: { start: parseInt(start.toString(), 10), end: parseInt(end.toString(), 10) } });
          break;
        }
      }
      if (!(start && end) && heightArrayLength) {
        start = start ? start : 1;
        end = end ? end : heightArrayLength;
        this.getPagingData.emit({ paging: { start: parseInt(start.toString(), 10), end: parseInt(end.toString(), 10) } });
      }
    } else {
      let start = 1;
      if (heightArrayLength === 0) {
        start = 0;
      }
      this.getPagingData.emit({ paging: { start: parseInt(start.toString(), 10), end: parseInt(heightArrayLength.toString(), 10) } });
    }
  }

  /**
   * by this mwthod we are setting every child container
   * height in an array so we can track that at the time
   *  of scroll on which element is in viewport area
   * @private
   * @memberOf ViewportPagingDirective
   */
  private setChildsHeight() {
    this.heightArray = [];
    let lastVal = 0;
    const childElements = this.directiveElement.querySelectorAll(`.${this.child}`);
    const childElementsLength = childElements.length;
    for (let i = 0; i < childElementsLength; i++) {
      lastVal += childElements[i].getBoundingClientRect().height;
      this.heightArray.push(lastVal);
    }
  }
}
